<div>
  <nav class="navbar_nu">
    <div class="left-data">
      <!---Burger Icon-->
      <div class="burger-menu-container" (mouseleave)="onMouseLeave($event)" #menuWrapper>
        <div class="burger-menu" (mouseenter)="toggleMenu(true)">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>
        @if (isMenuOpen) {
        <ul class="menu" (scroll)="onScroll($event)">
          @for (item of menuItems; track item) { @if (!(item.Content == 'Work Queues') || ( item.Content == 'Work
          Queues' && workQueuesRoles.includes(formattedRole))) {
          <li (mouseenter)="showSubMenu($event, item)" (mouseleave)="hideSubMenu(item)">
            <div
              class="menu-item"
              (click)="redirectView(item)"
              [ngClass]="{
                'nav-item-active': selectedRoute == item.Url_Path,
                'nav-main-item-active': parentRoute == item.Url_Path,
                'has-submenu': item.submenus && item.submenus.length > 0
              }"
            >
              <div class="left-menu-item">
                <!--Icon-->
                <img src="{{ item.icon }}" class="menu-icon" alt="{{ item.Content }} Icon" />
                <!--Name-->
                <span class="menu-name">{{ item.Content }}</span>
              </div>
              @if (item.submenus && item.submenus.length > 0) {
              <span class="menu-arrow">
                <mat-icon class="arrow-icon">{{
                  item.showSubmenu ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                }}</mat-icon>
              </span>
              }
            </div>
          </li>
          } }
        </ul>
        }
        <!--Submenu-->
        @if (submenuList && submenuList.length > 0) {
        <ul
          class="submenu"
          (mouseleave)="onSubmenuMouseLeave()"
          [ngStyle]="{ top: submenuPosition.top + 'px', left: submenuPosition.left + 'px' }"
        >
          @for (subItem of submenuList; track subItem) {
          <li
            (click)="redirectView(subItem, true)"
            [ngClass]="{ 'nav-item-active': selectedRoute == subItem.Url_Path }"
          >
            <div class="submenu-item">
              <img src="{{ subItem.icon }}" class="sub-menu-icon" alt="{{ subItem.Content }} Icon" />
              <span class="submenu-name">{{ subItem.Content }}</span>
            </div>
          </li>
          }
        </ul>
        }
      </div>

      <!--Logo-->
      <div class="navbar-brand pointer-event ps-3" (click)="redirectToHome()">
        <img class="header-logo" src="../../../../assets/imagesV4/menu-icons/techopshublogoimg.png" />
        {{ appName }}
      </div>
    </div>

    <!--Right mat icons-->
    <div class="icons">
      <div class="contact_us_block  ms-4">
        <img
          src="assets/imagesV4/menu-icons/contactusimg.png"
          title="Contact US"
          class="contact_us_icon"
          (click)="redirectToContactUs()"
          alt="Contact Us Icon"
        />
      </div>
      <div class="documentation_block ms-4">
        <img
          src="assets/imagesV4/menu-icons/doc1.png"
          title="Documentation"
          class="documentation_icon"
          (click)="redirectToUserManual()"
          alt="Documentation Icon"
        />
      </div>
      <div class="release_notes_block img_block ms-4">
        <img
          src="assets/imagesV4/menu-icons/releasenotesimg.png"
          title="Release Notes"
          class="release_notes_icon"
          (click)="redirectToRelease()"
          alt="Release Notes Icon"
        />
      </div>
      <div class="nav-item dropdown ms-4">
        <span
          id="navbarDropdownMenuLink3"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          [ngClass]="{ 'nav-item-active': selectedRoute == 'help' }"
        >
          <img src="assets/imagesV4/menu-icons/notificationsimg.png" class="help-icon" />
          @if (notifications.length>0) {
          <div [ngClass]="{ redCircle: !genericNotificationOnly, greenCircle: genericNotificationOnly }"></div>
          }
        </span>
        <div
          class="dropdown-menu dropdown-menu-right md-dropdown noti-dropdown"
          aria-labelledby="navbarDropdownMenuLink3"
        >
          <div class="notification-header">Notifications</div>
          @if (notifications.length>0) {
          <section class="notification-content">
            @for (eachNotificaation of notifications; track eachNotificaation) {
            <div class="notification">
              @if (eachNotificaation.Popup=='True'||eachNotificaation.Popup=='true') {
              <div class="notification-title d-flex popup-title">
                <p>{{ eachNotificaation.Content }}</p>
                <span class="pull-right notification-count" (click)="showNotificationPopup()">{{
                  eachNotificaation.total_count
                }}</span>
              </div>
              } @if (eachNotificaation.Popup!='True'&& eachNotificaation.Popup!='true') {
              <div class="notification-title d-flex">
                <p>{{ eachNotificaation.Content }}</p>
                <span class="pull-right notification-count">{{ eachNotificaation.total_count }}</span>
              </div>
              } @for (description of eachNotificaation.notifications; track description) {
              <p class="notification-desc" [innerHTML]="description.Notification_message | safeHtml"></p>
              }
            </div>
            }
          </section>
          } @if (notifications.length==0) {
          <section class="notification-content no-notification">
            <p>You have no notification right now</p>
          </section>
          }
        </div>
      </div>
      <div
        class="user_name-initials ms-4 me-2"
        data-toggle="tooltip"
        data-placement="bottom"
        title="{{ userNameFullDetails }}"
      >
        {{ userNameInitials }}
      </div>
    </div>
  </nav>
  @if (selectedRoute === 'landing-page' ? (landingHeaderLoaderStateService.loading$ | async) : showLoader) {
  <div class="stk-table-loader landing-page-header-loader">
    <app-loader> </app-loader>
  </div>
  }
</div>
<app-modal [maximizable]="true" [inViewport]="true" #notificationModal class="modal-demo notification-popup">
  <ng-container class="app-modal-body ">
    <div class="d-flex close-icon" (click)="closeNotificationModal()"><mat-icon>close</mat-icon></div>
    @if (showNotificationDetailPopup) {
    <app-notification-popup [notificationList]="notificationList"></app-notification-popup>
    }
  </ng-container>
</app-modal>
<app-modal [maximizable]="true" [inViewport]="true" #urgentActionReqModal class="urgent-action-popup">
  <ng-container class="app-modal-header">Urgent Action Required</ng-container>
  <ng-container class="app-modal-body ">
    @if (oldBucketDetails.length>0) {
    <div class="notification-details">
      @for (urgentNotification of oldBucketDetails; track urgentNotification) {
      <p class="notification-desc old-bucket" [innerHTML]="urgentNotification.Notification_message | safeHtml"></p>
      }
    </div>
    }
  </ng-container>
</app-modal>
